"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4238],{

/***/ 14238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductOverlay; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./adapters/helpers/Constants.js
var Constants = __webpack_require__(24036);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
;// CONCATENATED MODULE: ./adapters/model/service/api/buyNowLite.js
/* provided dependency */ var process = __webpack_require__(34155);





function generateHeader() {
  var header = new Headers();
  header.append(Constants/* BuyNowLiteConstants.accessControlAllowOrigin */.t8.accessControlAllowOrigin, '*');
  header.append(Constants/* BuyNowLiteConstants.passKey */.t8.passKey, process.env.BUY_NOW_LITE_PASS_KEY);
  header.append(Constants/* BuyNowLiteConstants.ocpApimSubscriptionKey */.t8.ocpApimSubscriptionKey, process.env.BUY_NOW_LITE_SUBSCRIPTION_KEY);
  return header;
}
var getBuyNowLiteRetailerList = function getBuyNowLiteRetailerList(sku) {
  var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var onFailure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var header = generateHeader();
  var requestOptions = {
    method: 'GET',
    headers: header
  };
  var url = process.env.BUY_NOW_LITE_URL.replace('{sku}', sku);
  fetch(url, requestOptions).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.constructor === Array) {
      onSuccess(data);
    } else {
      onFailure();
    }
  })["catch"](function (error) {
    console.error(error);
    onFailure();
  });
};
// EXTERNAL MODULE: ./adapters/helpers/Block.js
var Block = __webpack_require__(40483);
// EXTERNAL MODULE: ./adapters/helpers/Utils.js
var Utils = __webpack_require__(8996);
// EXTERNAL MODULE: ./adapters/helpers/Loader.js
var Loader = __webpack_require__(47322);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ProductOverlay/ProductOverlay.js
/* provided dependency */ var ProductOverlay_process = __webpack_require__(34155);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















var Icon = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});




function ProductOverlay(props) {
  var _block$getFieldValue, _block$getFieldValue$, _block$getFieldValue2, _block$getFieldValue3;

  var displayBuyNowLite = (ProductOverlay_process.env.ACTIVATE_BUY_NOW_LITE || false) === 'TRUE';
  var customEvent = props.customEvent,
      onClickCallback = props.onClickCallback,
      states = props.states,
      extraAttributes = props.extraAttributes;
  var block = new Block/* default */.Z(props);

  var _useState = (0,react.useState)(states.isOverlayOpen),
      isOverlayOpen = _useState[0],
      setIsOverlayOpen = _useState[1];

  var _useState2 = (0,react.useState)(null),
      lastButton = _useState2[0],
      setLastButton = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      lastScroll = _useState3[0],
      setLastScroll = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      productSku = _useState4[0],
      setProductSku = _useState4[1];

  var KEYCODE_ESC = 27;
  var anchorId = block.getAnchorId();
  var productOverlayRef = (0,react.useRef)();
  var closeOverlayLabel = (_block$getFieldValue = block.getFieldValue(Constants/* ProductOverlayConstants.closeOverlayLabel */.cj.closeOverlayLabel)) == null ? void 0 : (_block$getFieldValue$ = _block$getFieldValue.fields) == null ? void 0 : _block$getFieldValue$.text;
  var buyNowLiteErrorLabel = (_block$getFieldValue2 = block.getFieldValue(Constants/* ProductOverlayConstants.buyNowLiteErrorLabel */.cj.buyNowLiteErrorLabel)) == null ? void 0 : (_block$getFieldValue3 = _block$getFieldValue2.fields) == null ? void 0 : _block$getFieldValue3.text;
  var classNames = block.getFieldValue(Constants/* ProductOverlayConstants.classNames */.cj.classNames) ? block.getFieldValue(Constants/* ProductOverlayConstants.classNames */.cj.classNames) : Constants/* ProductOverlayConstants.empty */.cj.empty;
  classNames += "".concat(anchorId);
  (0,react.useEffect)(function () {
    var _extraAttributes$enti, _extraAttributes$enti2, _extraAttributes$enti3, _extraAttributes$enti4;

    setLastScroll(window.pageYOffset);
    var productVariants = extraAttributes == null ? void 0 : (_extraAttributes$enti = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti2 = _extraAttributes$enti.productOverview) == null ? void 0 : (_extraAttributes$enti3 = _extraAttributes$enti2.fields) == null ? void 0 : _extraAttributes$enti3.productVariants;
    var series = extraAttributes == null ? void 0 : (_extraAttributes$enti4 = extraAttributes.entity) == null ? void 0 : _extraAttributes$enti4.series;
    var initialSku = '';

    if (extraAttributes) {
      var _productVariants$, _productVariants$$fie, _series$, _series$$fields, _series$$fields$featu, _series$$fields$featu2, _series$$fields$featu3, _series$2, _series$2$fields, _series$2$fields$feat, _series$2$fields$feat2, _series$2$fields$feat3, _series$2$fields$feat4;

      if ((productVariants == null ? void 0 : productVariants.length) > 0 && ((_productVariants$ = productVariants[0]) == null ? void 0 : (_productVariants$$fie = _productVariants$.fields) == null ? void 0 : _productVariants$$fie.sku)) {
        var _extraAttributes$enti5, _extraAttributes$enti6, _extraAttributes$enti7, _extraAttributes$enti8, _extraAttributes$enti9;

        initialSku = extraAttributes == null ? void 0 : (_extraAttributes$enti5 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti6 = _extraAttributes$enti5.productOverview) == null ? void 0 : (_extraAttributes$enti7 = _extraAttributes$enti6.fields) == null ? void 0 : (_extraAttributes$enti8 = _extraAttributes$enti7.productVariants[0]) == null ? void 0 : (_extraAttributes$enti9 = _extraAttributes$enti8.fields) == null ? void 0 : _extraAttributes$enti9.sku;
      } else if ((series == null ? void 0 : series.length) > 0 && ((_series$ = series[0]) == null ? void 0 : (_series$$fields = _series$.fields) == null ? void 0 : (_series$$fields$featu = _series$$fields.featuredProduct) == null ? void 0 : (_series$$fields$featu2 = _series$$fields$featu.fields) == null ? void 0 : (_series$$fields$featu3 = _series$$fields$featu2.productVariants) == null ? void 0 : _series$$fields$featu3.length) > 0 && ((_series$2 = series[0]) == null ? void 0 : (_series$2$fields = _series$2.fields) == null ? void 0 : (_series$2$fields$feat = _series$2$fields.featuredProduct) == null ? void 0 : (_series$2$fields$feat2 = _series$2$fields$feat.fields) == null ? void 0 : (_series$2$fields$feat3 = _series$2$fields$feat2.productVariants[0]) == null ? void 0 : (_series$2$fields$feat4 = _series$2$fields$feat3.fields) == null ? void 0 : _series$2$fields$feat4.sku)) {
        var _extraAttributes$enti10, _extraAttributes$enti11, _extraAttributes$enti12, _extraAttributes$enti13, _extraAttributes$enti14, _extraAttributes$enti15, _extraAttributes$enti16;

        initialSku = extraAttributes == null ? void 0 : (_extraAttributes$enti10 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti11 = _extraAttributes$enti10.series[0]) == null ? void 0 : (_extraAttributes$enti12 = _extraAttributes$enti11.fields) == null ? void 0 : (_extraAttributes$enti13 = _extraAttributes$enti12.featuredProduct) == null ? void 0 : (_extraAttributes$enti14 = _extraAttributes$enti13.fields) == null ? void 0 : (_extraAttributes$enti15 = _extraAttributes$enti14.productVariants[0]) == null ? void 0 : (_extraAttributes$enti16 = _extraAttributes$enti15.fields) == null ? void 0 : _extraAttributes$enti16.sku;
      }
    }

    setProductSku(initialSku);
  }, []);

  var onGetBuyNowLiteRetailerListSuccess = function onGetBuyNowLiteRetailerListSuccess(data) {
    var buyNowLiteContainer = document.querySelector('.buy-now-lite-container');

    var _iterator = _createForOfIteratorHelper(data),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var linkNode = document.createElement('a');
        linkNode.href = item.BuyNowUrl;
        linkNode.target = '_blank';
        linkNode.rel = 'noopener noreferrer';
        linkNode.className = 'buy-now-lite-link';
        var imgNode = document.createElement('img');
        imgNode.src = 'data:image/png;base64,' + item.Retailerlogo;
        imgNode.className = 'buy-now-lite-img';
        imgNode.alt = '';
        linkNode.appendChild(imgNode);
        buyNowLiteContainer.appendChild(linkNode);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    openBuyNowLiteModal();
  };

  var onGetBuyNowLiteRetailerListFailure = function onGetBuyNowLiteRetailerListFailure() {
    // close modal and remove buy now lite retailer images from modal.
    var buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
    var paragraphNode = document.createElement('p');
    paragraphNode.className = 'buy-now-lite-error-message';
    paragraphNode.textContent = buyNowLiteErrorLabel;
    buyNowLiteContainer.appendChild(paragraphNode);
    openBuyNowLiteModal();
  };

  (0,react.useEffect)(function () {
    if (!(customEvent == null ? void 0 : customEvent.event)) {
      return;
    }

    if (customEvent.event instanceof HTMLElement || customEvent.event instanceof Node) {
      var _customEvent$event, _customEvent$event$da, _customEvent$event2, _customEvent$event2$d;

      if (displayBuyNowLite) {
        customEvent.event.disabled = true;
      }

      var sku = (customEvent == null ? void 0 : (_customEvent$event = customEvent.event) == null ? void 0 : (_customEvent$event$da = _customEvent$event.dataset) == null ? void 0 : _customEvent$event$da.sku) ? customEvent.event.dataset.sku : '';
      var resetCountryCode = (customEvent == null ? void 0 : (_customEvent$event2 = customEvent.event) == null ? void 0 : (_customEvent$event2$d = _customEvent$event2.dataset) == null ? void 0 : _customEvent$event2$d.resetCountryCode) ? customEvent.event.dataset.resetCountryCode : false; // ACTIVATE_BUY_NOW_LITE is true for japan

      if (ProductOverlay_process.env.ACTIVATE_BUY_NOW_LITE === 'TRUE') {
        if (sku !== '') {
          // Ajax call to get retailer data.
          getBuyNowLiteRetailerList(sku, onGetBuyNowLiteRetailerListSuccess, onGetBuyNowLiteRetailerListFailure);
        } else {
          // If no sku, close modal and remove buy now lite retailer images from modal.
          var buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
          buyNowLiteContainer.innerHTML = '';
          closeBuyNowLiteModal();
        }
      } else {
        var _window;

        // Price spider buy now case.
        if (sku !== '' && window.PriceSpider === undefined) {
          // script priceSpider with callback
          (0,Utils/* loadScript */.ve)(Constants/* ProductOverlayConstants.priceSpiderSource */.cj.priceSpiderSource, function (error) {
            if (error) {
              console.log(Constants/* ProductOverlayConstants.priceSpiderConsoleLogMessageError */.cj.priceSpiderConsoleLogMessageError);
            } else {
              // script loaded successfully
              setProductSku(sku);
              setLastButton(customEvent.event);
              setIsOverlayOpen(true);
            }
          });
        } else if (sku !== '') {
          // script already loaded
          setProductSku(sku);
          setLastButton(customEvent.event);
          setIsOverlayOpen(true);
        } else {
          setProductSku('');
          setIsOverlayOpen(false);
        }

        if (resetCountryCode && ((_window = window) == null ? void 0 : _window.PriceSpider)) {
          window.PriceSpider.reset();
        }
      }
    }
  }, [customEvent]);
  (0,react.useEffect)(function () {
    var _window2;

    if (productSku !== '' && ((_window2 = window) == null ? void 0 : _window2.PriceSpider)) {
      window.PriceSpider.rebind();
    }
  }, [productSku]);
  (0,react.useEffect)(function () {
    if (productOverlayRef == null ? void 0 : productOverlayRef.current) {
      toggleOverlay();
      productOverlayRef.current.addEventListener(Constants/* ProductOverlayConstants.keydown */.cj.keydown, trapFocusInOverlay);
      return function () {
        var _productOverlayRef$cu;

        (_productOverlayRef$cu = productOverlayRef.current) == null ? void 0 : _productOverlayRef$cu.removeEventListener(Constants/* ProductOverlayConstants.keydown */.cj.keydown, trapFocusInOverlay);
      };
    }
  }, [isOverlayOpen]);
  (0,react.useEffect)(function () {
    var handleScroll = throttle_default()(function () {
      if (!document.body.classList.contains(Constants/* ProductOverlayConstants.noScroll */.cj.noScroll)) {
        setLastScroll(window.pageYOffset);
      }
    }, 100);
    window.addEventListener(Constants/* ProductOverlayConstants.scroll */.cj.scroll, handleScroll);
    return function () {
      var _window3;

      (_window3 = window) == null ? void 0 : _window3.removeEventListener(Constants/* ProductOverlayConstants.scroll */.cj.scroll, handleScroll);
    };
  }, [lastScroll]);

  var closeBuyNowLiteModal = function closeBuyNowLiteModal() {
    setProductSku('');
    setIsOverlayOpen(false);
  };

  var openBuyNowLiteModal = function openBuyNowLiteModal() {
    if (displayBuyNowLite) {
      customEvent.event.disabled = false;
    }

    setLastButton(customEvent.event);
    setIsOverlayOpen(true);
  };

  var toggleOverlay = function toggleOverlay() {
    var productOverlayElem = productOverlayRef.current;
    var ele = document.getElementById('ob-product-subnav-scroll');

    if (isOverlayOpen) {
      if (ele) {
        ele.setAttribute('style', 'z-index:99 !important');
      }

      productOverlayElem.classList.add(Constants/* ProductOverlayConstants.isActive */.cj.isActive);
      productOverlayElem.focus();
    } else {
      if (ele) {
        ele.setAttribute('style', 'z-index:999 !important');
      }

      productOverlayElem.classList.remove(Constants/* ProductOverlayConstants.isActive */.cj.isActive);
      document.body.style.top = null;
      document.body.style.height = null;

      if (lastButton) {
        lastButton.focus();
      }
    }

    (0,Utils/* toggleScroll */.a9)(isOverlayOpen, lastScroll);
  };

  var trapFocusInOverlay = function trapFocusInOverlay(event) {
    if (!isOverlayOpen) {
      return;
    }

    var element = event.currentTarget;
    var focusableElements = element.querySelectorAll(Constants/* ProductOverlayConstants.querySelectorAll */.cj.querySelectorAll);
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var KEYCODE_TAB = 9;
    var isTabPressed = event.key === Constants/* ProductOverlayConstants.Tab */.cj.Tab || event.keyCode === KEYCODE_TAB;
    handleEscapeKeyPress(event);

    if (!isTabPressed) {
      return;
    }

    if (event.shiftKey)
      /* shift + tab */
      {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        }
      } else
      /* tab */
      {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
  };

  var handleBackgroundClick = function handleBackgroundClick(event) {
    event.stopPropagation();

    if (event.target === document.querySelector('.ob-product-overlay')) {
      setIsOverlayOpen(false);

      if (displayBuyNowLite) {
        // When clicking in background remove buy now lite retailer.
        var buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
        buyNowLiteContainer.innerHTML = '';
      }
    }
  };

  var handleEscapeKeyPress = function handleEscapeKeyPress(event) {
    if (event.key === Constants/* ProductOverlayConstants.Escape */.cj.Escape || event.keyCode === KEYCODE_ESC) {
      setIsOverlayOpen(false);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader["default"], {}),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      role: "presentation",
      onClick: handleBackgroundClick,
      onKeyDown: handleEscapeKeyPress,
      ref: productOverlayRef,
      className: "ob-product-overlay ".concat(classNames),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "ob-product-overlay__wrapper ".concat(displayBuyNowLite ? 'ob-product-overlay__wrapper--buy-now-lite' : ''),
        children: [isOverlayOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "aria-label": closeOverlayLabel,
          className: 'ob-product-overlay__close-btn',
          onClick: function onClick(event) {
            return onClickCallback(event);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
            name: Constants/* ProductOverlayConstants.close */.cj.close,
            size: 2,
            color: "#002d72"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          id: "ob-product-overlay__content",
          children: displayBuyNowLite ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "buy-now-lite-container"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ps-widget",
              "ps-sku": productSku,
              "data-action-detail": productSku
            })
          })
        })]
      })
    })
  });
}
ProductOverlay.defaultProps = {
  states: {
    isOverlayOpen: false
  }
};

/***/ })

}]);